import { ENGINE_POSITION } from "../constants/trendGraph/enginesLine";
import localizationKeys from "../i18n/localizationKeys";

export const mapEnginePosition = (data, isFleet = false) => {
  const formatEnginePosition = (engine) => {
    const isNumeric = /^\d+$/.test(engine.position);
    if (!isNumeric) return engine;
    
    const position = parseInt(engine.position, 10);
    const column = position % 3;
    const positionNo = Math.floor(position / 3) + 1;

    let positionText = '';
    if (column === 0) positionText = 'Center';
    else if (column === 1) positionText = 'Port';
    else positionText = 'Starboard';

    return {
      ...engine,
      position: positionText,
      positionNo,
    };
  };

  if (isFleet) {
    return data.map(item => ({
      ...item,
      vesselLatestMainEngineData: item?.vesselLatestMainEngineData?.map(formatEnginePosition),
    }));
  } else {
    return data.map(formatEnginePosition);
  }
};

export const handleEngineNumber = (mainEngineData, t, isMonitoringPage = false) => {
  const enginePositions = mainEngineData.map(d => {
    return {
      position: d.position,
      positionNo: d.positionNo ?? 1,
    }
  }).filter(d => d.position !== '');

  const order = { Center: 0, Port: 1, Starboard: 2 };
  const labels = { Center: localizationKeys.Center_abbreviation, Port: localizationKeys.Port_abbreviation, Starboard: localizationKeys.Starboard_abbreviation };

  enginePositions.sort((a, b) => {
    const posCompare = order[a.position] - order[b.position];
    if (posCompare !== 0) return posCompare;
    return a.positionNo - b.positionNo;
  });

  if (isMonitoringPage) {
    return enginePositions.map((item, idx) => ({
      position: `${t(labels[item.position])}${item.positionNo.toString()}`,
      number: idx + 1,
      name: `${t(labels[item.position])}${item.positionNo.toString()}`,
    }));
  } else {
    return enginePositions.map((item, idx) => ({
      label: `${t(labels[item.position])}${item.positionNo.toString()}`,
      position: idx + 1,
      positionText: item.position,
      positionNo: item.positionNo,
    }));
  }
};

export const handleGraphData = (mainEngineData, t) => {
  const enginePositions = mainEngineData.map(d => {
    return {
      ...d,
      position: d.position,
      positionNo: d.positionNo ?? 1,
    }
  }).filter(d => d.position !== '');

  const order = { Center: 0, Port: 1, Starboard: 2 };
  const labels = { Center: localizationKeys.Center_abbreviation, Port: localizationKeys.Port_abbreviation, Starboard: localizationKeys.Starboard_abbreviation };

  enginePositions.sort((a, b) => {
    const posCompare = order[a.position] - order[b.position];
    if (posCompare !== 0) return posCompare;
    return a.positionNo - b.positionNo;
  });

  return enginePositions.map((item, idx) => ({
    ...item,
    label: `${t(labels[item.position])}${item.positionNo.toString()}`,
  }));
};

export const convertPositionTextToNumeric = (positionText) => {
  switch (positionText) {
    case ENGINE_POSITION.CENTER: return 0;
    case ENGINE_POSITION.PORT: return 1;
    case ENGINE_POSITION.STARBOARD: return 2;
    default: return 0;
  }
}